import { Markdown } from "@/components/ai/chat/Markdown";
import { useProgressiveText } from "@/hooks/use-progressive-text";
import type { AgentMessageFragmentText } from "@/hooks/use-stream-conversation";
import type { PlainAgentExecution } from "@/queries/agent-queries";
import { agentExecutionLoading } from "@/utils/agent-executions";
import { cn } from "@/components/podkit/lib/cn";
import { type FC } from "react";

export const FragmentText: FC<{
    fragment: AgentMessageFragmentText;
    agentExecution?: PlainAgentExecution;
    shouldHighlight?: boolean;
}> = ({ fragment, agentExecution, shouldHighlight = false }) => {
    const isAgentRunning = agentExecutionLoading(agentExecution);
    const isCompleted = fragment.completed || !isAgentRunning;
    const { text } = useProgressiveText(fragment.content, { speed: 10, enabled: !isCompleted });

    // Remove summary heading if present (case-insensitive)
    const contentToDisplay = isCompleted ? fragment.content : text;
    const processedContent = shouldHighlight
        ? contentToDisplay.replace(/^#+\s*summary\s*\n*/i, "")
        : contentToDisplay;

    return (
        <div>
            {shouldHighlight && (
                <div className="mb-2 text-xs font-medium text-content-muted">Summary</div>
            )}
            <div
                data-completed={isCompleted}
                className={cn({
                    "rounded-lg border border-border-base bg-surface-secondary p-4": shouldHighlight,
                })}
            >
                <Markdown content={processedContent} />
            </div>
        </div>
    );
};
